import React, { useState } from 'react';
import styled from '@emotion/styled';
import CommonSection from '../../../components/CommonSection';
import TimetableSection from '../../program/TimetableSection';
import Embed from './Embed';
import { useLocalization } from "gatsby-theme-i18n";
import { useStaticQuery, graphql } from "gatsby"
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import { useCurrentTime } from '../../../functions/useCurrentTime';


const StreamingSection = () => {

  const { day1List, day2List } = useStaticQuery(graphql`
    query StreamingSection {
      day1List: allProgram(
        sort: {fields: data___start_time, order: ASC}
        filter: {data: {status: {eq: "publish"}, date: {eq: "1"}}}
      ) {
        edges {
          node {
            annotation {
              ...localizedContent
            }
            title {
              ...localizedContent
            }
            time {
              ...localizedContent
            }
            data {
              update_date
              type
              stream_url
              status
              start_time
              key
              end_time
              date
            }
            desc {
              ...localizedContent
            }
            thumb {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
              }
            }
            visual {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
              }
            }
            performers { ...localizedContent }
            guests {
              name { ...localizedContent }
              title { ...localizedContent }
              tooltip { ...localizedContent }
              image {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                  )
                }
              }
              thumb {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                  )
                }
              }
            }
          }
        }
      }
  
      day2List: allProgram(
        sort: {fields: data___start_time, order: ASC}
        filter: {data: {status: {eq: "publish"}, date: {eq: "2"}}}
      ) {
        edges {
          node {
            annotation {
              ...localizedContent
            }
            title {
              ...localizedContent
            }
            time {
              ...localizedContent
            }
            data {
              update_date
              type
              stream_url
              status
              start_time
              key
              end_time
              date
            }
            desc {
              ...localizedContent
            }
            thumb {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
              }
            }
            visual {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
              }
            }
            performers { ...localizedContent }
            guests {
              name { ...localizedContent }
              title { ...localizedContent }
              tooltip { ...localizedContent }
              image {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                  )
                }
              }
              thumb {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                  )
                }
              }
            }
          }
        }
      }
      
    }
  `); 

  const { currentTime } = useCurrentTime();
  const { t } = useLocalization();

  const [ currentDay, setCurrentDay ] = useState(1);


  return (
  
  <StreamingWrapper>
    <TabWrapper>
      <Tab>
        <TabLink href="#" className={currentDay === 1 ? 'active' : ''} onClick = {(e) => {
          e.preventDefault();
          setCurrentDay(1);
        }}>{t('event.date.day1.label')}</TabLink>
        <TabLink href="#" className={currentDay === 2 ? 'active' : ''} onClick = {(e) => {
          e.preventDefault();
          setCurrentDay(2);
        }}>{t('event.date.day2.label')}</TabLink>
      </Tab>
    </TabWrapper>
    <div className="bottomWrapper">
      <EmbedWrapper>
        <Embed 
          currentDay={currentDay}  />
      </EmbedWrapper>
      <TimetableWrapper>
        <TimetableSection 
          list={currentDay === 1 ? day1List : day2List}
          defaultVisual={'special_live_piano'}
          position={'right'}
          id={currentDay === 1 ? 'day1' : 'day2'} 
          type={'streaming'}
          currentTime={currentTime}
        />
      </TimetableWrapper>
    </div>
  </StreamingWrapper >
  );
}
 
export default StreamingSection;

const StreamingWrapper = styled(CommonSection)`
  margin-top:144px;
  width: 100%;
  > div{
    display:block;
  }

  > div > div{
    max-width:1824px;
  }

  .bottomWrapper{
    display:flex;
    padding-bottom: 0;
    justify-content: space-between;
    align-items:flex-start;
  }

  

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin-top:125px;
    .bottomWrapper{
      display:block;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-top:109px;
  }
`

const EmbedWrapper = styled.div`
  width:calc(100% - 464px);

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
  }
`

const TimetableWrapper = styled.div`
  width: 432px;
  
  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
  }
`

const TabWrapper = styled.div`
  margin-bottom:48px;
  display:flex;
  justify-content: center;

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin-bottom:32px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-bottom:24px;
  }
`

const Tab = styled.div`
  
  display:flex;
  overflow: hidden;
    
`
const TabLink = styled.a`
  display:block;
  color: #4E4E50;
  padding:10px 22px;
  text-decoration: none;
  font-weight:bold;
  border: 2px solid #4E4E50;
  font-size: 16px;
  line-height: 24px;

  &.active{
    background: #2C2C2E;
    color: #FCFCFF;
    border-color: #2C2C2E;
  }

  &:first-of-type{border-radius: 24px 0px 0px 24px;}
  &:last-of-type{border-radius:  0px 24px 24px 0px;}

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 14px;
    line-height: 22px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 20px;
    padding:6px 12px;
    &:first-of-type{padding-right:10px;}
    &:last-of-type{padding-left:10px;}
  }
    
`
